module.exports = __webpack_public_path__ + "../resources/img/ic_scan_gray100.5defe3ce.svg";